import React from 'react'

import loading from '../../../assets/img/disk.gif'

export const AppLoading = () => <div className="text-center"><img src={ loading } alt='Loading...' /></div>